import { useLocation, useNavigate } from 'react-router-dom';
import './logsForm.css';
import { useState } from 'react';
import { ReactComponent as SaveProceedingSVG } from '../images/saveProceeding.svg';
import { ReactComponent as LeftSvg } from '../images/left.svg';
import { SquaredIcon } from '../components/squaredIcon';
import { post } from './utils/utils';
import { AgendaItem } from './agenda';
import { useAuth } from '../context/context';

export function AgendaForm() {
    const { state }: { state: AgendaItem } = useLocation();
    const [id] = useState(state.id);
    const [startDate, setStartDate] = useState<Date | undefined>(state.startDate);
    const [endDate, setEndDate] = useState<Date | undefined>(state.endDate);
    const [startTime, setStartTime] = useState(state.startTime);
    const [endTime, setEndTime] = useState(state.endTime);
    const [content, setContent] = useState(state.content);
    let navigate = useNavigate();
    const { user } = useAuth();

    if(!state.id) {
        return (
            <div>
                <p>Ocurrió un error al cargar la información, por favor regresa a la Agenda e intenta de nuevo.</p>
            </div>
        )
    }

    function addAgendaItem(event: React.SyntheticEvent<HTMLFormElement>) {
        event.preventDefault();
        if(id) {
            const newAgendaItem: AgendaItem = {
                id,
                startDate,
                endDate,
                startTime,
                endTime,
                content,
              };
              const formData = new FormData();
              if(newAgendaItem.endDate) {
                  formData.append('endDate', newAgendaItem.endDate.toISOString().split('T')[0]);
                } else {
                  formData.append('endDate', 'null');
              }
              if(newAgendaItem.startDate) {
                  formData.append('startDate', newAgendaItem.startDate.toISOString().split('T')[0]);
              }
              formData.append('startTime', newAgendaItem.startTime ?? '');
              formData.append('endTime', newAgendaItem.endTime ?? '');
              formData.append('content', newAgendaItem.content ?? '');
              formData.append('id', id);
              post({
                url: 'putAgendaItem.php',
                data: formData,
                token: user.token,
              })
                .then((response) => response.data)
                .then((data) => {
                  if (data.status === 'ok') {
                    alert('Agenda modificada exitosamente!')
                  }
                });
        }
    }

    return (
        <div className='logsForm-container'>
            <form onSubmit={addAgendaItem}>
                <div className='logForm-header'>
                    <div className='clickable' onClick={() => navigate('/agenda')}>
                        <LeftSvg style={{width: "20px", height: "20px"}} />
                    </div>
                    <div className='proceedings-submit'>
                        <p>Finalizar registro</p>
                        <button type='submit'>
                            <SquaredIcon icon={<SaveProceedingSVG className='clickable' />} />
                        </button>
                    </div>
                </div>
                <div className='proceedings-section-line'></div>
                <div className="log-new-item">
                    <div className='log-new-item-input'>
                        <label htmlFor='startDate'>Fecha de inicio: </label>
                        <input
                            aria-label="Time"
                            type="date"
                            className="agenda-input"
                            id='startDate'
                            required
                            value={startDate ? new Date(startDate.getTime() + Math.abs(startDate.getTimezoneOffset()*60000)).toISOString().split('T')[0] : undefined}
                            onChange={(event) => {
                                if(event.target.value) {
                                    setStartDate(new Date(event.target.value))
                                } else {
                                    setStartDate(undefined);
                                }
                            }}
                        />
                    </div>
                    <div className='log-new-item-input'>
                        <label htmlFor='startTime'>Hora de inicio: </label>
                        <input
                            aria-label="Time"
                            type="time"
                            className="agenda-input"
                            id='startTime'
                            value={startTime ?? ''}
                            onChange={(event) => setStartTime(event.target.value)}
                        />
                    </div>
                    <div className='log-new-item-input'>
                        <label htmlFor='endDate'>Fecha de fin: </label>
                        <input
                            aria-label="Time"
                            type="date"
                            className="agenda-input"
                            id='endDate'
                            value={endDate ? new Date(endDate.getTime() + Math.abs(endDate.getTimezoneOffset()*60000)).toISOString().split('T')[0] : undefined}
                            onChange={(event) => {
                                if(event.target.value) {
                                    setEndDate(new Date(event.target.value))
                                } else {
                                    setEndDate(undefined);
                                }
                            }}
                        />
                    </div>
                    <div className='log-new-item-input'>
                        <label htmlFor='endTime'>Hora de fin: </label>
                        <input
                            aria-label="Time"
                            type="time"
                            className="agenda-input"
                            id='endTime'
                            value={endTime ?? ''}
                            onChange={(event) => setEndTime(event.target.value)}
                        />
                    </div>
                    
                    <div className='log-new-item-input'>
                        <label htmlFor='content'>Contenido: </label>
                        <textarea
                            required
                            id='content'
                            className="agenda-input"
                            placeholder="Añadir contenido"
                            value={content}
                            rows={4}
                            onChange={(event) => setContent(event.target.value)}
                        />
                    </div>
                </div>
            </form>
        </div>
    )
}